import { Link } from 'react-router-dom';
import styles from './SimpleHeader.module.css';

/**
 * process/apply/privacy/terms 4개 서브 페이지가 공통으로 쓰는 단순 헤더.
 * (홈페이지의 풍성한 sticky nav와는 다른 별도 컴포넌트 — HomeNav 참고)
 */
export default function SimpleHeader() {
  return (
    <header id="top" className={styles.header}>
      <div className={`wrap ${styles.inner}`}>
        <Link to="/" className={styles.logoLink}>
          <img src="/assets/logo_ko_cut.png" alt="English POP" />
        </Link>
        <Link to="/" className={styles.back}>
          ← 홈으로
        </Link>
      </div>
    </header>
  );
}
